import UpdateOrDeleteField from "./updateOrDeleteFieldModal";

export default UpdateOrDeleteField;